import { __assign } from "tslib";
import { createHttpTestKit } from '../http/test-kit';
import { createFakePostResponder, createFakeGetResponder, createFakePutResponder, isWildcard } from '../test-utils';
import { createKbApi } from './';
import { createFakeDeleteResponder } from '../test-utils';
export var createKbApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createKbApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetAdminTree: function (dto) {
            return createFakeGetResponder(fakeHttp, "/categories/admin?locale=" + (isWildcard(dto) ? 'en' : dto.locale) + (isWildcard(dto) ? '' : "" + (!!dto.brandId ? "&brandId=" + dto.brandId : '')));
        },
        whenGetTree: function (dto) {
            return createFakeGetResponder(fakeHttp, "/categories?locale=" + dto.locale + (!isWildcard(dto) && dto.brandId ? "&brandId=" + dto.brandId : ''));
        },
        whenAddArticle: createFakePostResponder(fakeHttp, '/articles'),
        whenAddCategory: function (dto, fail) {
            return createFakePostResponder(fakeHttp, '/categories', fail)(dto);
        },
        whenAddSubcategory: function (dto, fail) {
            var parentId = isWildcard(dto) ? 'some-id' : dto.parentId;
            return createFakePostResponder(fakeHttp, '/categories/' + parentId, fail)(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { parentId: undefined }));
        },
        whenUpdateCategory: function (dto) {
            // tslint:disable-next-line:max-line-length
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            return createFakePutResponder(fakeHttp, '/categories/' + id)(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenDeleteCategory: function (dto) {
            return createFakeDeleteResponder(fakeHttp, "/categories/" + (isWildcard(dto) ? 'some-id' : "" + dto.id + (dto.brandId ? "?brandId=" + dto.brandId : '')));
        },
        whenDeleteArticle: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            var locale = isWildcard(dto) ? 'en' : dto.locale;
            return createFakeDeleteResponder(fakeHttp, "/articles/" + id + "?locale=" + locale);
        },
        whenPublishArticle: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "/articles/" + id + "/publish")(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenUnpublishArticle: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "/articles/" + id + "/unpublish")(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenGetCategoryArticlesCount: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "/articles/category/count/admin")(dto);
        },
        whenMoveArticle: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            return createFakePostResponder(fakeHttp, "/articles/" + id + "/move")(dto);
        },
        whenMoveSubcategory: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            // tslint:disable-next-line:max-line-length
            return createFakePutResponder(fakeHttp, "/categories/" + id + "/parent")(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenSortCategories: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePostResponder(fakeHttp, "/categories/sort")(dto);
        },
        whenAddArticleTranslations: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            return createFakePostResponder(fakeHttp, "/articles/" + id + "/translations")(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenUpdateArticleLabels: function (dto) {
            var id = isWildcard(dto) ? 'some-id' : dto.id;
            return createFakePutResponder(fakeHttp, "/articles/" + id + "/labels")(__assign(__assign({}, (isWildcard(dto) ? {} : dto)), { id: undefined }));
        },
        whenDuplicateArticle: function (dto) {
            return createFakePostResponder(fakeHttp, '/articles/duplicate')(__assign({}, (isWildcard(dto) ? {} : dto)));
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map